// extracted by mini-css-extract-plugin
export var skipAnimation = "_1b-0";